"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplitflapCore = exports.convert2dDualRowZigZagTo1dChainlink = exports.convert1dChainlinkTo2dDualRowZigZag = exports.cobsEncode = exports.cobsDecode = void 0;
const CRC32 = __importStar(require("crc-32"));
const splitflapjs_proto_1 = require("splitflapjs-proto");
const cobs_1 = require("./cobs");
Object.defineProperty(exports, "cobsDecode", { enumerable: true, get: function () { return cobs_1.decode; } });
Object.defineProperty(exports, "cobsEncode", { enumerable: true, get: function () { return cobs_1.encode; } });
const util_1 = require("./util");
Object.defineProperty(exports, "convert1dChainlinkTo2dDualRowZigZag", { enumerable: true, get: function () { return util_1.convert1dChainlinkTo2dDualRowZigZag; } });
Object.defineProperty(exports, "convert2dDualRowZigZagTo1dChainlink", { enumerable: true, get: function () { return util_1.convert2dDualRowZigZagTo1dChainlink; } });
class SplitflapCore {
    constructor(onMessage, sendBytes) {
        this.outgoingQueue = [];
        this.lastNonce = 1;
        this.retryTimeout = null;
        this.portAvailable = false;
        this.buffer = new Uint8Array();
        this.lastNonce = Math.floor(Math.random() * (2 ^ (32 - 1)));
        this.onMessage = onMessage;
        this.sendBytes = sendBytes;
    }
    sendConfig(config) {
        this.enqueueMessage(splitflapjs_proto_1.PB.ToSplitflap.create({
            splitflapConfig: config,
        }));
    }
    sendModuleCommand(position, command) {
        const modules = Array(position + 1).fill(splitflapjs_proto_1.PB.SplitflapCommand.ModuleCommand.create({ action: splitflapjs_proto_1.PB.SplitflapCommand.ModuleCommand.Action.NO_OP }));
        modules[position] = command;
        this.enqueueMessage(splitflapjs_proto_1.PB.ToSplitflap.create({
            splitflapCommand: splitflapjs_proto_1.PB.SplitflapCommand.create({
                modules,
            })
        }));
    }
    saveAllOffsets() {
        this.enqueueMessage(splitflapjs_proto_1.PB.ToSplitflap.create({
            splitflapCommand: splitflapjs_proto_1.PB.SplitflapCommand.create({
                saveAllOffsets: true,
            })
        }));
    }
    offsetIncrementTenth(position) {
        this.sendModuleCommand(position, splitflapjs_proto_1.PB.SplitflapCommand.ModuleCommand.create({ action: splitflapjs_proto_1.PB.SplitflapCommand.ModuleCommand.Action.INCREASE_OFFSET_TENTH }));
    }
    offsetIncrementHalf(position) {
        this.sendModuleCommand(position, splitflapjs_proto_1.PB.SplitflapCommand.ModuleCommand.create({ action: splitflapjs_proto_1.PB.SplitflapCommand.ModuleCommand.Action.INCREASE_OFFSET_HALF }));
    }
    offsetSetToCurrentStep(position) {
        this.sendModuleCommand(position, splitflapjs_proto_1.PB.SplitflapCommand.ModuleCommand.create({ action: splitflapjs_proto_1.PB.SplitflapCommand.ModuleCommand.Action.SET_OFFSET }));
    }
    /**
     * Perform a hard reset of the splitflap MCU. May take a few seconds.
     */
    hardReset() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("Not implemented!");
        });
    }
    onStart() {
        this.enqueueMessage(splitflapjs_proto_1.PB.ToSplitflap.create({
            requestState: splitflapjs_proto_1.PB.RequestState.create(),
        }));
    }
    onReceivedData(data) {
        var _a, _b;
        this.buffer = Uint8Array.from([...this.buffer, ...data]);
        let i;
        // Iterate 0-delimited packets
        while ((i = this.buffer.indexOf(0)) != -1) {
            const raw_buffer = this.buffer.subarray(0, i);
            const packet = (0, cobs_1.decode)(raw_buffer);
            this.buffer = this.buffer.slice(i + 1);
            if (packet.length <= 4) {
                console.debug(`Received short packet ${this.buffer.slice(0, i)}`);
                continue;
            }
            const payload = packet.slice(0, packet.length - 4);
            // Validate CRC32
            const crc_buf = packet.slice(packet.length - 4, packet.length);
            const provided_crc = crc_buf[0] | (crc_buf[1] << 8) | (crc_buf[2] << 16) | (crc_buf[3] << 24);
            const crc = CRC32.buf(payload);
            if (crc !== provided_crc) {
                console.debug(`Bad CRC. Expected ${crc} but received ${provided_crc}`);
                console.debug(raw_buffer.toString());
                continue;
            }
            let message;
            try {
                message = splitflapjs_proto_1.PB.FromSplitflap.decode(payload);
            }
            catch (err) {
                console.warn(`Invalid protobuf message ${payload}`);
                return;
            }
            // TODO: add protocolVersion to spec
            // if (message.protocolVersion !== PROTOBUF_PROTOCOL_VERSION) {
            //     console.warn(
            //         `Invalid protocol version. Expected ${PROTOBUF_PROTOCOL_VERSION}, received ${message.protocolVersion}`,
            //     )
            //     return
            // }
            if (message.payload === 'ack') {
                const nonce = (_b = (_a = message.ack) === null || _a === void 0 ? void 0 : _a.nonce) !== null && _b !== void 0 ? _b : undefined;
                if (nonce === undefined) {
                    console.warn('Received ack without nonce');
                }
                else {
                    this.handleAck(nonce);
                }
            }
            this.onMessage(message);
        }
    }
    enqueueMessage(message) {
        if (!this.portAvailable) {
            return;
        }
        // TODO: add protocolVersion to spec
        // message.protocolVersion = PROTOBUF_PROTOCOL_VERSION
        message.nonce = this.lastNonce++;
        // Encode before enqueueing to ensure messages don't change once they're queued
        const payload = splitflapjs_proto_1.PB.ToSplitflap.encode(message).finish();
        if (this.outgoingQueue.length > 10) {
            console.warn(`Splitflap outgoing queue overflowed! Dropping ${this.outgoingQueue.length} pending messages!`);
            this.outgoingQueue.length = 0;
        }
        this.outgoingQueue.push({
            nonce: message.nonce,
            encodedToSplitflapPayload: payload,
        });
        this.serviceQueue();
    }
    handleAck(nonce) {
        if (this.outgoingQueue.length > 0 && nonce === this.outgoingQueue[0].nonce) {
            if (this.retryTimeout !== null) {
                clearTimeout(this.retryTimeout);
                this.retryTimeout = null;
            }
            this.outgoingQueue.shift();
            this.serviceQueue();
        }
        else {
            console.log(`Ignoring unexpected ack for nonce ${nonce}`);
        }
    }
    serviceQueue() {
        if (!this.portAvailable) {
            return;
        }
        if (this.retryTimeout !== null) {
            // Retry is pending; let the pending timeout handle the next step
            return;
        }
        if (this.outgoingQueue.length === 0) {
            return;
        }
        const { encodedToSplitflapPayload: payload } = this.outgoingQueue[0];
        const crc = CRC32.buf(payload);
        const crcArray = [crc & 0xff, (crc >>> 8) & 0xff, (crc >>> 16) & 0xff, (crc >>> 24) & 0xff];
        const packet = new Uint8Array(payload.length + 4);
        packet.set(payload, 0);
        packet.set(crcArray, payload.length);
        const cobsEncodedPacket = (0, cobs_1.encode)(packet);
        const encodedDelimitedPacket = new Uint8Array(cobsEncodedPacket.length + 1);
        encodedDelimitedPacket.set(cobsEncodedPacket, 0);
        encodedDelimitedPacket.set([0], cobsEncodedPacket.length);
        this.retryTimeout = setTimeout(() => {
            this.retryTimeout = null;
            console.log(`Retrying ToSplitflap...`);
            this.serviceQueue();
        }, SplitflapCore.RETRY_MILLIS);
        console.debug(`Sent ${payload.length} byte payload with CRC ${(crc >>> 0).toString(16)} (${cobsEncodedPacket.length} bytes encoded)`, encodedDelimitedPacket);
        this.sendBytes(encodedDelimitedPacket);
    }
}
exports.SplitflapCore = SplitflapCore;
SplitflapCore.RETRY_MILLIS = 250;
SplitflapCore.BAUD = 230400;
SplitflapCore.USB_DEVICE_FILTERS = [
    // 10c4:ea60 Silicon Labs CP210x UART Bridge
    {
        usbVendorId: 0x10c4,
        usbProductId: 0xea60,
    },
    // 1a86:55d4 QinHeng Electronics USB Single Serial
    {
        usbVendorId: 0x1a86,
        usbProductId: 0x55d4,
    },
];
